import BackboneMixin from 'lib/backbone_mixin.js'

export default class StoryAssetsMixin extends BackboneMixin
  reloadAssetsAndActivities: ->
    if page.get("storyLayoutView")?
      page.get("storyLayoutView").reloadAssets()
      page.get("storyLayoutView").reloadActivities()

  reloadActivities: ->
    if page.get("storyLayoutView")?
      page.get("storyLayoutView").reloadActivities()

  reloadAssets: ->
    if page.get("storyLayoutView")?
      page.get("storyLayoutView").reloadAssets()

  showAssets: ->
    if page.get("storyLayoutView")?
      page.get("storyLayoutView").showAssets()



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/mixins/story_assets_mixin.js.coffee